import React, { useEffect, useState } from "react";
import "../localMunicipalCouncil/LocalMunicipalCouncil.css";
import "../../../assets/fonts/Fonts.css";
import { stateImages } from "../CoatOfArms";
import { Link } from "react-router-dom";
import api from "../../../services/baseUrl";
export default function MedalHonours() {
  const [states, setStates] = useState([]);

  useEffect(() => {
    const fetchLibraries = async () => {
      try {
        const response = await api.get(
          "/api/egazette-documents/libraries/all",

          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const filteredResponse = response.data.filter(
          (item) => item.orderId !== null
        );

        setStates(filteredResponse);
      } catch (error) {}
    };
    fetchLibraries();
  }, []);

  // const replaceSpacesWithNbsp = (text) => {
  //   if (!text || typeof text !== "string") {
  //     return text; // Return as-is if text is not a string or is null/undefined
  //   }
  //   return text.replace(/ /g, "\u00A0");
  // };
  return (
    <div className="">
      <div className="local-municipal-council-content">
        <div className="local-municipal-council-announcement">
          Medal Honours is a recognition system that celebrates individuals for <br />
          their outstanding contributions across various fields, including public service, <br />
          arts, and sustainability. The Datukship, a prestigious Malaysian honorary title, <br />
          is conferred for exceptional service to society, while sustainability awards <br />
          honour efforts in environmental conservation and sustainable development. <br />
          This list serves as a reference for recipients of Datukships and other sustainability-related honours.<br />
        </div>
        {/* <div style={{ padding: "0 25px" }}>
          <Search />
        </div> */}
        <div
          className="local-municipal-council-state-gallery"
          style={{ padding: "35px" }}
        >
          {states.map((item, index) => (
            <Link key={index} to={`${item.id}`} className="gallery-item">
              <img
                src={stateImages[index]}
                alt={`${item.name} Logo`}
                className="gallery-image"
              />
              <p className="gallery-name">{item.displayName} </p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
